import React from "react";
import cx from "classnames";
import styles from "./OurOffers.module.scss";
import Image from "@components/Image";
import Link from "@components/Link";
import ClipText from "@components/ClipText/ClipText";
import Button from "@components/Button";
import { useTranslationContext } from "@providers/TranslationProvider";
import { useRouteContext } from "@providers/RouteProvider";
import { useBookingContext } from "@providers/BookingProvider";
import { usePageContext } from "@providers/PageProvider";

interface Props {
  data: {
    image: {
      src: string;
      alt: string;
    };
    title: string;
    description: string | React.ReactNode;
    expiryDate: string;
  };
}

export default function Item({ data }: Props) {
  const { i18n } = useTranslationContext();
  const { router } = useRouteContext();
  const { booking } = useBookingContext();
  const { hotel } = usePageContext();
  const handler = {
    book: (e: any) => {
      e.preventDefault();
      e.stopPropagation();
      booking.open({ hotel });
    },
  };
  return (
    <Link href={router.toUrl("offer-detail", data)}>
      <div className={cx(styles.item)}>
        <Image
          scale={1.02}
          wrapperProps={{ className: cx(styles.image) }}
          src={data.image.src}
          alt={data.image.alt}
          layout="fill"
          objectFit="cover"
        />
        <ClipText fixedRows rows={2} className={cx(styles.title)}>
          {data.title}
        </ClipText>
        <ClipText fixedRows rows={3} className={cx(styles.content)}>
          {data.description}
        </ClipText>

        <div className={cx(styles.footer)}>
          <div className={cx(styles.validTime)}>{data.expiryDate}</div>
          <div className={cx(styles.btnGroup)}>
            <Button
              type="text"
              className={styles.discoverMoreBtn}
              label={i18n.t("Button.discoverMore")}
            />
            <Button
              className={styles.reserveBtn}
              label={i18n.t("Button.reserve")}
              onClick={handler.book}
            />
          </div>
        </div>
      </div>
    </Link>
  );
}
